import { useMemo, useState } from 'react';

export const UseSortLoadingMessages = (messageArray1, messageArray2) => {
  const requestLoadingMessages = useMemo(() => messageArray1, []);

  const tipsMessages = useMemo(() => messageArray2, []);

  const firstArray = useMemo(() => {
    const out = [];
    requestLoadingMessages.forEach((loading, i) => {
      out.push(loading);
      if (tipsMessages[i]) out.push(tipsMessages[i]);
    });
    return out;
  }, [requestLoadingMessages, tipsMessages]);

  const secondArray = useMemo(() => {
    const loading = messageArray1.at(-1);
    const out = [];
    tipsMessages.forEach((tip) => { out.push(loading, tip); });
    return out;
  }, [tipsMessages]);

  const [isDoneFirstArray, setIsDoneFirstArray] = useState(false);
  const messagesArray = !isDoneFirstArray ? firstArray : secondArray;

  return { messagesArray,firstArray, secondArray, setIsDoneFirstArray, isDoneFirstArray };
};